import { render, staticRenderFns } from "./dashboard_nuevo.vue?vue&type=template&id=7a56cca7&scoped=true"
import script from "./dashboard_nuevo.vue?vue&type=script&lang=js"
export * from "./dashboard_nuevo.vue?vue&type=script&lang=js"
import style0 from "./dashboard_nuevo.vue?vue&type=style&index=0&id=7a56cca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a56cca7",
  null
  
)

export default component.exports